<template>
  <profile class="companyprofile" :options="options">
    <template #header>
      <div id="welcome_row">
        <div class="mainWrap mt-5">
          <div class="row">
            <div class="col-6 col-sm-6">
              <h1 class="h1-white">
                Welcome,<br />
                {{
                  companyStore.userCompany?.name ?? userStore.authUser?.userName
                }}
              </h1>
            </div>
            <div id="trim_image" class="d-lg-block d-none col-6">
              <img
                class="me-2"
                src="@/assets/img/ui/plcnext_pfeile.svg"
                alt="PLCNext arrows logo"
              />
            </div>
          </div>
        </div>
      </div>
    </template>
    <slot />
  </profile>
</template>

<script lang="ts" setup>
import Profile from "~/components/shared/layout/profile.vue";
import { useUserStore } from "~/stores/userstore";
import {
  PhFactory,
  PhMapPin,
  PhUserPlus,
  PhCertificate,
  PhUsers,
  PhBook,
  PhCurrencyDollar,
} from "@phosphor-icons/vue";
import { useCompanyStore } from "~/stores/companystore";

const userStore = useUserStore();
const companyStore = useCompanyStore();
const options = computed(() => {
  const companyId = userStore.authUser?.companyId;
  const userUuid = userStore.authUserUuid;

  const baseOptions = [
    {
      name: "Profile",
      link: `/users/${userUuid}/company/${companyId}/profile`,
      icon: PhFactory,
    },
  ];

  if (userStore.isCompanyAdmin) {
    baseOptions.push(
      {
        name: "Address",
        link: `/users/${userUuid}/company/${companyId}/profile/address`,
        icon: PhMapPin,
      },
      {
        name: "EBilling",
        link: `/users/${userUuid}/company/${companyId}/profile/ebilling`,
        icon: PhCurrencyDollar,
      },
      {
        name: "Invites",
        link: `/users/${userUuid}/company/${companyId}/profile/invites`,
        icon: PhUserPlus,
      },
    );

    if (companyStore.userCompany?.approvedContributor) {
      baseOptions.push({
        name: "Certificates",
        link: `/users/${userUuid}/company/${companyId}/profile/certificates`,
        icon: PhCertificate,
      });
    }
  }

  baseOptions.push(
    {
      name: "Members",
      link: `/users/${userUuid}/company/${companyId}/profile/members`,
      icon: PhUsers,
    },
    {
      name: "Journal",
      link: `/users/${userUuid}/company/${companyId}/profile/journal`,
      icon: PhBook,
    },
  );

  return baseOptions;
});
</script>
<!-- does not work with scoped because the template is defined in profile.vue layout -->
<style lang="scss">
@use "@/sass/layouts/Companyprofile.scss" as *;
</style>
